import React from 'react'
import DataComponent from 'EurestoComponents/DataComponent'
import Constants from 'EurestoFonction/Constants'

export default class extends React.Component {

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return this.props.information_tiers[this.props.info.id] !== nextProps.information_tiers[nextProps.info.id] || this.props.disabled !== nextProps.disabled
  }

  constructor(props) {
    super(props)
  }

  render() {
    let libelle = this.props.info.libelle

    return <DataComponent key={this.props.info.id} title={libelle} onChange={this.props.onChangeInfo}
      name={this.props.info.id} disabled={this.props.disabled} infoTiers
      inline={this.props.inline}
      object={Constants.donnee.info_tiers_donnees} module={Constants.module.GESTION} search={{
        information_tiers_id: this.props.info.id,
        actif: {
          not: true,
          value: 3
        }
      }} data={this.props.information_tiers[this.props.info.id]} type={this.props.info.type_saisie_id} />
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/InformationTiers/Data.js